export default __webpack_public_path__ + "static/media/create_post_mobile.c3bb0202.svg";